import React from 'react';
import classes from '../../../../assets/Global.module.css';

function Summary({ data }: { data: DATTruckPostBoardItem }) {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
  };

  const posted = data?.posted ? new Date(data?.posted) : null;
  const formattedPosted = posted
    ? posted.toLocaleString(undefined, options).replace(',', ' @')
    : '';

  const lastUpdated = data?.lastUpdated ? new Date(data?.lastUpdated) : null;
  const formattedLastUpdated = lastUpdated
    ? lastUpdated.toLocaleString(undefined, options).replace(',', ' @')
    : '';

  const formatEquipment = (
    data: DATTruckPostBoardItem | undefined | null,
  ): string => {
    if (!data) return '';
    const name = data.datEquipmentName ?? '';
    const length = data.length ? `${data.length}ft` : '';
    return `${name} ${length}`;
  };

  const formatCityState = (city: string, state: string): string => {
    if (!city && !state) return '';
    return `${city ?? ''}${state ? `, ${state}` : ''}`;
  };

  return (
    <div className={classes.viewGrid}>
      <div className={classes.attribute}>
        <h3>Posted</h3>
        <span>{formattedPosted ?? ''}</span>
      </div>

      <div className={`${classes.attribute} ${classes.span2}`}>
        <h3>Last Updated</h3>
        <span>{formattedLastUpdated ?? ''}</span>
      </div>

      <div className={classes.attribute}>
        <h3>Equipment</h3>
        <span>{formatEquipment(data)}</span>
      </div>

      <div className={`${classes.attribute} ${classes.span2}`}>
        <h3>Weight</h3>
        <span>{data?.weight ?? ''}</span>
      </div>

      <div className={classes.attribute}>
        <h3>Origin</h3>
        <span>{formatCityState(data?.originCity, data?.originState)}</span>
      </div>

      <div className={`${classes.attribute} ${classes.span2}`}>
        <h3>Destination</h3>
        <span>
          {formatCityState(data?.destinationCity, data?.destinationState)}
        </span>
      </div>

      <div className={classes.attribute}>
        <h3>Earliest Availability</h3>
        <span>{data?.earliestAvailableDate ?? ''}</span>
      </div>

      <div className={`${classes.attribute} ${classes.span2}`}>
        <h3>Latest Availability</h3>
        <span>{data?.latestAvailableDate ?? ''}</span>
      </div>

      <div className={`${classes.attribute} ${classes.span3}`}>
        <h3>Comment</h3>
        <span>{data?.comment ?? ''}</span>
      </div>
    </div>
  );
}
export default Summary;
